import { Component, Input, Output, EventEmitter } from '@angular/core'
import { BaseComponent } from '../../../components/base.component'
import { UserQueries } from 'graphql/queries/user.queries'

@Component({
  selector: 'video-purchase-modal',
  template: `
    <modal [removeVisible]="false" [width]="600">
      <ng-template [ngIf]="step === 'buy'">
        <h4 class="small-top-buffer">
          Add a video for only {{price}}... Or subscribe & save $10!
        </h4>
        <hr class="brand-hr"/>
        <p class="top-buffer h4-subheader">
          Create more engagement in your content and on social media with a 30-60 second teaser or summary video. We'll turn the words we wrote into an engaging slideshow video.
          <a href="https://help.verblio.com/pro-services-and-products/how-to-receive-videos-with-your-purchased-content" target="_blank">Learn more</a>
        </p>
        <button class="blue-button tiny-right-buffer biggish-text" [disabled]="purchaseInProgress" (click)="onPurchase()">I want a video!</button>
        <button class="secondary-outline-button biggish-text" (click)="close.emit()">Not now</button>
        <div class="small-top-buffer small-text">You will be charged {{price}} as a one-time payment</div>
      </ng-template>
      <ng-template [ngIf]="step === 'survey'">
        <h4 class="small-top-buffer">
            3, 2, …1 MORE THING!
        </h4>
        <hr class="brand-hr"/>
        <p class="top-buffer h4-subheader">
          Our team is now ready to create a video based on the piece you selected. Before we can work our magic, we need some info from you. The more details you give, the better quality video we can give you.
        </p>
        <a class="btn btn-secondary mr-2" target="_blank" (click)="close.emit()" [href]="videoFormUrl">Open survey in new tab</a>
      </ng-template>
    </modal>
  `
})
export class VideoPurchaseModal extends BaseComponent {
  @Input() step: 'buy' | 'survey' = 'buy';
  @Input() price: string;
  @Output() purchase: EventEmitter<null> = new EventEmitter<null>();
  @Output() close: EventEmitter<null> = new EventEmitter<null>();

  @Input() businessName: string
  @Input() postTitle: string
  email: string

  purchaseInProgress = false

  constructor(private userQueries: UserQueries) {
    super()
  }

  ngOnInit(): void {
    const userEmailObs = this.userQueries.userEmailQuery().subscribe((email) => {
      this.email = email
    })
    this.observers.push(userEmailObs)
  }

  get videoFormUrl(): string {
    const businessNameKey = 'entry.1605886761'
    const businessName = encodeURI(this.businessName)

    const postTitleKey = 'entry.270923909'
    const postTitle = encodeURI(this.postTitle)

    const emailKey = 'emailAddress'
    const email = encodeURI(this.email)

    return `https://docs.google.com/forms/d/1VLPWuKiBGONZ8g7ZT5HdZGT6lZ03DN3XskfFVC1Z3kk/viewform?usp=sharing&${emailKey}=${email}&${postTitleKey}=${postTitle}&${businessNameKey}=${businessName}`
  }

  onPurchase(): void {
    this.purchaseInProgress = true
    this.purchase.emit()
  }
}
